import React, { useEffect, useState } from "react";
import { Table, Button, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useAuth } from "../Context/AuthContext";

export default function ViewJVScreen() {
  const { user } = useAuth();
  const orgId = user?.organisationId?.toString();

  const [unapprovedJVs, setUnapprovedJVs] = useState([]);
  const [approvedJVs, setApprovedJVs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [error, setError] = useState("");

  const fetchJVs = async () => {
    if (!orgId) return;
    setLoading(true);
    setError("");

    try {
      const [unapprovedRes, approvedRes] = await Promise.all([
        axios.get(`${Base_URL}/JVScreen/GetUnapprovedJV/${orgId}`),
        axios.get(`${Base_URL}/JVScreen/GetApprovedJV/${orgId}`),
      ]);

      setUnapprovedJVs(unapprovedRes.data || []);
      setApprovedJVs(approvedRes.data || []);
    } catch (err) {
      setError("Failed to load JV data.");
      console.error(err);
    }
    setLoading(false);
  };

  const approveJV = async (jvheaderId) => {
    setApprovingId(jvheaderId);
    try {
      await axios.put(`${Base_URL}/JVScreen/PostJVToAccounting/${jvheaderId}`);
      await fetchJVs(); // Refresh UI
    } catch (err) {
      alert("Failed to approve JV.");
      console.error(err);
    } finally {
      setApprovingId(null);
    }
  };

  useEffect(() => {
    fetchJVs();
  }, [orgId]);

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString() : "-";

  return (
    <div className="container mt-4">
      <h4 className="fw-bold mb-4">Journal Voucher Approval</h4>

      {error && <Alert variant="danger">{error}</Alert>}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          {/* ==================== Unapproved JVs ==================== */}
          <h5 className="fw-semibold text-danger">Unapproved JV</h5>
          <Table bordered hover responsive size="sm" className="mb-4">
            <thead className="table-secondary">
              <tr>
                <th>Header ID</th>
                <th>Company</th>
                <th>FY</th>
                <th>Posting Date</th>
                <th>Document Date</th>
                <th>Document Type</th>
                <th>Reference</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {unapprovedJVs.length > 0 ? (
                unapprovedJVs.map((item) => (
                  <tr key={item.jvheaderId}>
                    <td>{item.jvheaderId}</td>
                    <td>{item.companyCode}</td>
                    <td>{item.fy}</td>
                    <td>{formatDate(item.postingDate)}</td>
                    <td>{formatDate(item.documentDate)}</td>
                    <td>{item.documentType}</td>
                    <td>{item.referenceNumber}</td>
                    <td>{formatDate(item.createdOn)}</td>
                    <td className="text-center">
                      <Button
                        size="sm"
                        variant="success"
                        disabled={approvingId === item.jvheaderId}
                        onClick={() => approveJV(item.jvheaderId)}
                      >
                        {approvingId === item.jvheaderId ? (
                          <Spinner animation="border" size="sm" />
                        ) : (
                          "Approve"
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center text-muted">
                    No unapproved JVs available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* ==================== Approved JVs ==================== */}
          <h5 className="fw-semibold text-success">Approved JV</h5>
          <Table bordered hover responsive size="sm">
            <thead className="table-success">
              <tr>
                <th>Header ID</th>
                <th>Company</th>
                <th>FY</th>
                <th>Posting Date</th>
                <th>Document Date</th>
                <th>Document Type</th>
                <th>Reference</th>
                <th>Created On</th>
              </tr>
            </thead>
            <tbody>
              {approvedJVs.length > 0 ? (
                approvedJVs.map((item) => (
                  <tr key={item.jvheaderId}>
                    <td>{item.jvheaderId}</td>
                    <td>{item.companyCode}</td>
                    <td>{item.fy}</td>
                    <td>{formatDate(item.postingDate)}</td>
                    <td>{formatDate(item.documentDate)}</td>
                    <td>{item.documentType}</td>
                    <td>{item.referenceNumber}</td>
                    <td>{formatDate(item.createdOn)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center text-muted">
                    No approved JVs yet
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
}
